import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OneMonthFreeMode, OneMonthFreeStep} from "../../one-month-free.component";
import features from "./fetures.json";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";

interface Point {
  title: string;
  desc?: string;
  subPoints?: string[];
}

@Component({
    selector: 'db-one-month-free-features',
    templateUrl: './one-month-free-features.component.html',
    styleUrls: ['./one-month-free-features.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OneMonthFreeFeaturesComponent implements OnInit {

  @Input() mode: OneMonthFreeMode;
  @Input() isAgency: boolean = false;

  @Output() onClose = new EventEmitter<void>();
  @Output() onStepChange = new EventEmitter<OneMonthFreeStep>();

  public isMobile: boolean = false;

  public points: Point[] = [];

  constructor(
    private readonly activeModal: DbActiveModal,
  ) {
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
    this._getFeatures();
  }

  public resizeToNormal(): void {
    this.activeModal.resize(600, 940);
  }

  private _getFeatures(): void {
    if (['editor', 'builder', 'ssh'].includes(this.mode)) {
      this.points.push({title: 'Unlock all of 10Web'});
    }
    if (this.isAgency) {
      if (this.mode === 'editor') {
        this.points[0].subPoints = features['agency'];
      }
      if (this.mode === 'builder') {
        this.points[0].subPoints = features['builder'];
      }
      if (['optimize', 'wp-admin', 'general', 'feature', 'general', 'creation'].includes(this.mode)) {
        this.points = features['newPoints'];
      }

      /*this.mode !== 'wp-admin' && this.mode !== 'builder' && this.points.push({
        title: 'Get dedicated Slack Channel for VIP support',
        desc: 'Work directly with our engineers to solve any issue.'
      });*/
    } else {
      switch (this.mode) {
        case "builder":
          this.points.unshift(
            {
              title: 'Use out drag & drop editor based in Elementor'
            },
            {
              title: 'Generate content and images of your website'
            }
          );
          this.points[2].subPoints = features['builder'];
          break;

        default:
          this.points = features['newPoints'];
      }
    }
    if (this.mode === 'editor') {
      this.points.unshift(
        {
          title: 'Use out drag & drop editor based in Elementor'
        },
        {
          title: 'Generate content and images of your website'
        }
      );
      this.points[2].subPoints = features['builder'];
    }
  }

}
